import React, { useState, useEffect } from 'react';

const UNITS = [
  { value: 'm', label: 'Menit'  },
  { value: 'h', label: 'Jam'    },
  { value: 'd', label: 'Hari'   },
  { value: 'w', label: 'Minggu' },
  { value: 'M', label: 'Bulan'  },
];

function parse(str) {
  if (!str) return { amount: '', unit: 'd' };
  const m = String(str).match(/^(\d+)([mhdwM])$/);
  if (m) return { amount: m[1], unit: m[2] };
  return { amount: str, unit: 'd' };
}

export default function DurationInput({ label, value, onChange }) {
  const [amount, setAmount] = useState(() => parse(value).amount);
  const [unit, setUnit]     = useState(() => parse(value).unit);

  useEffect(() => {
    const p = parse(value);
    setAmount(p.amount);
    setUnit(p.unit);
  }, [value]);

  const emit = (a, u) => {
    if (!a) { onChange(''); return; }
    onChange(`${a}${u}`);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {label && <label style={{ fontSize: 12, color: 'var(--text-secondary)', fontWeight: 500 }}>{label}</label>}
      <div style={{ display: 'flex', gap: 6 }}>
        <input
          type="number" min={1} value={amount}
          onChange={e => { setAmount(e.target.value); emit(e.target.value, unit); }}
          placeholder="0"
          style={{
            flex: 1, background: 'var(--bg-input)', border: '1px solid var(--border)',
            borderRadius: 'var(--radius)', padding: '8px 10px',
            color: 'var(--text-primary)', fontSize: 13, outline: 'none',
            fontFamily: 'var(--font-sans)', minWidth: 0,
          }}
        />
        <select
          value={unit}
          onChange={e => { setUnit(e.target.value); emit(amount, e.target.value); }}
          style={{
            background: 'var(--bg-input)', border: '1px solid var(--border)',
            borderRadius: 'var(--radius)', padding: '8px 10px',
            color: 'var(--text-primary)', fontSize: 13, outline: 'none',
            cursor: 'pointer', fontFamily: 'var(--font-sans)',
          }}
        >
          {UNITS.map(u => (
            <option key={u.value} value={u.value}>{u.label}</option>
          ))}
        </select>
      </div>
      {value
        ? <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>→ <span className="mono" style={{ color: 'var(--accent-cyan)' }}>{value}</span></span>
        : <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Kosong = tidak ada batas expired</span>
      }
    </div>
  );
}